import React from "react";
import { Button } from "./ui/button";
import { Card } from "./ui/card";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";

const CTASection = () => {

  const scrollToOfferForm = () => {
    const offerSection = document.getElementById("offer-submission");
    if (offerSection) {
      const y = offerSection.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 to-green-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Ready to Sell Your House Fast?</h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Stop waiting for traditional buyers. Get your fair cash offer today and close in just 2–3 weeks.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">

          {/* Phone CTA */}
          <Card className="p-8 bg-white/10 backdrop-blur-sm text-white border-white/20 hover:bg-white/20 transition-all duration-300">
            <Phone className="h-12 w-12 text-yellow-300 mb-4" />
            <h3 className="text-xl font-bold mb-3">Call Now</h3>
            <p className="text-blue-100 mb-6">
              Speak directly with our property specialists. Get answers to all your questions.
            </p>
            <a
              href="tel:+1-888-334-3524"
              className="inline-flex items-center justify-center w-full bg-yellow-500 hover:bg-yellow-400 text-gray-900 font-bold py-3 px-6 rounded-lg transition-colors"
            >
              1-888-334-3524
              <ArrowRight className="h-5 w-5 ml-2" />
            </a>
          </Card>

          {/* Form CTA */}
          <Card className="p-8 bg-white/10 backdrop-blur-sm text-white border-white/20 hover:bg-white/20 transition-all duration-300">
            <MessageCircle className="h-12 w-12 text-green-300 mb-4" />
            <h3 className="text-xl font-bold mb-3">Get Your Offer</h3>
            <p className="text-blue-100 mb-6">
              Fill out our quick form and receive your cash offer within 24 hours.
            </p>
            <Button 
              onClick={scrollToOfferForm}
              className="w-full bg-green-500 hover:bg-green-400 text-gray-900 font-bold py-3"
            >
              Start My Offer
              <ArrowRight className="h-5 w-5 ml-2" />
            </Button>
          </Card>

        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <h3 className="text-2xl font-bold mb-4">Don't Wait – Every Day Counts</h3>
            <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
              The longer you wait, the more money you could be losing. Market conditions change daily.
              Get your offer today and secure your financial future.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                onClick={scrollToOfferForm}
                size="lg"
                className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 text-lg font-bold rounded-lg"
              >
                Get My Cash Offer Now
              </Button>

              <Button
                variant="outline"
                size="lg"
                className="border-2 border-white text-white hover:bg-white hover:text-blue-600 px-8 py-4 text-lg font-bold rounded-lg"
                onClick={() => window.location.href = 'tel:1-888-334-3524'}
              >
                Call 1-888-334-3524
              </Button>
            </div>

            <p className="text-sm text-blue-200 mt-4">
              No obligation • No pressure • Completely confidential
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default CTASection;
